import {CurrencyIsoEnum} from './enums/CurrencyIso.enum';
import {PriceTypeEnum} from './enums/PriceType.enum';


export class PriceModel {
  public currencyIso: CurrencyIsoEnum = null;
  public value: number;
  public priceType: PriceTypeEnum = null;
  public formattedValue: string = null;
  public formattedValueNoCurrency: string = null;

  static sample(): PriceModel {
    const price = new PriceModel();

    price.currencyIso = CurrencyIsoEnum.PLN;
    price.value = 299.0;
    price.priceType = PriceTypeEnum.BUY;
    price.formattedValue = '299,00 zł';
    price.formattedValueNoCurrency = '299,00';

    return price;
  }
}
